import React from "react";
import { MaintenanceLayout } from "components/template";
import { SearchEngineOptimizationProvider } from "providers/SearchEngineOptimizationProvider";

const Maintenance: React.FC = () => {
  return (
    <>
      <SearchEngineOptimizationProvider
        title="EduBay is under maintenance"
        description="Edubay a one-stop for all your education needs!"
        name="Cogninet"
        type="website"
        url="http://localhost:3000"
      />
      <MaintenanceLayout />
    </>
  );
};

export default Maintenance;
